import { injectIntl, IntlShape } from 'react-intl';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import { useState } from 'react';
import CorpoRegulationRecap from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/CorpoRegulationRecap';
import MaterialRegulationRecap from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/MaterialRegulationRecap';
import { get, isEmpty } from 'lodash';
import { getExpanded } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/utils';
import { AssignedLawyer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { ClaimRecapType } from 'typings/claimTypes';

export interface RegulationRecapProps {
  intl: IntlShape;
  setRiskRecap: Function;
  riskRecap: any;
  listings: Listings;
  activeStep: number;
  setActiveStep: Function;
  rcCorporeal: any;
  additionalWarrenties: any;
  rcMaterial: any;
  corpoEncryptedDocuments: any;
  substituteDocumentNature: SagisConfig[];
  corpoEncryptedDocumentsResult: any;
  lossDate: any;
  materialEncryptedDocuments: any;
  sagisClaim: any;
  showValidationButton: boolean;
  claimRecap: ClaimRecapType;
  judgementOnMeritsByVictims: any;
  setEncryptedDocumentsOfAdults: Function;
  setEncryptedDocumentsOfMinors: Function;
  encryptedDocumentsOfMinors: any;
  encryptedDocumentsOfAdults: any;
  assignedLawyers: AssignedLawyer[];
  setBase64Url: Function;
  base64Url: any;
  provisionInfo: any;
  setProvisionInfo: Function;
  hasJom: boolean;
  corpoRegulations: any;
  policyInfo: any;
  lastSagisClaim: any;
  showDialog: boolean;
  setErrorSummarySheet: Function;
  isBasicManagementRegulation?: boolean;
}

export const RegulationRecap: React.FC<RegulationRecapProps> = ({
  setRiskRecap,
  riskRecap,
  listings,
  setActiveStep,
  rcCorporeal,
  rcMaterial,
  additionalWarrenties,
  activeStep,
  corpoEncryptedDocuments,
  substituteDocumentNature,
  corpoEncryptedDocumentsResult,
  sagisClaim,
  materialEncryptedDocuments,
  claimRecap,
  ...props
}): JSX.Element => {
  const [expanded, setExpanded] = useState({
    ...getExpanded(rcCorporeal, riskRecap),
    ...getExpanded(rcMaterial, riskRecap),
    ...getExpanded(additionalWarrenties, riskRecap),
  });
  const handleChangeExpanded = (item: any, field: string) => (
    event: React.ChangeEvent<{}>,
  ) => {
    const expandedRisks = { ...expanded } as any;
    expandedRisks[item.regulationId] = {
      ...expanded[item.regulationId],
      [field]: !get(expanded[item.regulationId], field, false),
    };
    setExpanded(expandedRisks);
  };
  return (
    <main>
      {!isEmpty(rcCorporeal) && (
        <CorpoRegulationRecap
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          riskRecap={riskRecap}
          setRiskRecap={setRiskRecap}
          listings={listings}
          corpoEncryptedDocuments={corpoEncryptedDocuments}
          substituteDocumentNature={substituteDocumentNature}
          corpoEncryptedDocumentsResult={corpoEncryptedDocumentsResult}
          expanded={expanded}
          rcCorporeal={rcCorporeal}
          handleChangeExpanded={handleChangeExpanded}
          lossDate={props.lossDate}
          showValidationButton={props.showValidationButton}
          claimRecap={claimRecap}
          judgementOnMerits={props.judgementOnMeritsByVictims}
          sagisClaim={sagisClaim}
          encryptedDocumentsOfMinors={props.encryptedDocumentsOfMinors}
          setEncryptedDocumentsOfMinors={props.setEncryptedDocumentsOfMinors}
          encryptedDocumentsOfAdults={props.encryptedDocumentsOfAdults}
          setEncryptedDocumentsOfAdults={props.setEncryptedDocumentsOfAdults}
          assignedLawyers={props.assignedLawyers}
          setBase64Url={props.setBase64Url}
          base64Url={props.base64Url}
          provisionInfo={props.provisionInfo}
          setProvisionInfo={props.setProvisionInfo}
          hasJom={props.hasJom}
          corpoRegulations={props.corpoRegulations}
          policyInfo={props.policyInfo}
          lastSagisClaim={props.lastSagisClaim}
          showProvisionDialog={props.showDialog}
          setErrorSummarySheet={props.setErrorSummarySheet}
          isBasicManagementRegulation={props.isBasicManagementRegulation}
        />
      )}
      {!isEmpty(rcMaterial) && (
        <MaterialRegulationRecap
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          riskRecap={riskRecap}
          setRiskRecap={setRiskRecap}
          listings={listings}
          expanded={expanded}
          risk={rcMaterial}
          handleChangeExpanded={handleChangeExpanded}
          materialEncryptedDocuments={materialEncryptedDocuments}
          sagisClaim={sagisClaim}
        />
      )}
      {!isEmpty(additionalWarrenties) && (
        <MaterialRegulationRecap
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          riskRecap={riskRecap}
          setRiskRecap={setRiskRecap}
          listings={listings}
          expanded={expanded}
          risk={additionalWarrenties}
          handleChangeExpanded={handleChangeExpanded}
          materialEncryptedDocuments={materialEncryptedDocuments}
          sagisClaim={sagisClaim}
        />
      )}
    </main>
  );
};

export default injectIntl(RegulationRecap);
